import React from "react";
import styled from "@emotion/styled";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";
import HighlightCarousel from "./HighlightCarousel/HighlightCarousel";

const ContainerSection = styled.section`
  overflow-x: hidden;
`;

const HighlightCard = () => {
  const array_card = [
    {
      _id: "1",
      card_canva: {
        bg_color_mobile: "rgba(0, 0, 0, 0.2)",
        bg_color_desktop:
          "linear-gradient( to right, transparent 10%, rgb(0, 0, 0) 70%,rgba(0, 0, 0, 0.99) 75% )",
      },
      card_heading: {
        style_render: "992",
        main_container_css: "",
        container_mobile_styles: false,
        container_desktop_styles: false,
        obj_heading: {
          main_text: "<span class='t-enlace'>Structured</span> Learning Path",
          main_tag_version: "h3",
          main_text_css: "t-h-3",
          heading_mobile_styles: {
            "text-align": "center",
            "margin-bottom": "0.5rem",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          heading_desktop_styles: {
            "text-align": "left",
          },
        },
        obj_support_heading: false,

        obj_divider: {
          divider_mobile_styles: {
            width: "100%",
            background:
              "linear-gradient(90deg, transparent, #e6c28b, transparent)",
            margin: "0 auto 2rem auto",
          },
          divider_desktop_styles: {
            width: "70%",
            background: "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
            margin: "0 0 2rem 0",
          },
        },
        obj_paragraph: {
          main_text:
            "See exactly what to train, when to train it, and how everything connects. No guessing. No random videos. Just a clear path forward.",
          main_tag_version: "p",
          main_text_css: "",
          paragraph_mobile_styles: {
            "text-align": "center",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          paragraph_desktop_styles: {
            "text-align": "left",
          },
        },
        obj_buttons: false,
        heading_version: "heading_01",
      },

      card_content: {
        type: "img",
        src_content:
          "https://res.cloudinary.com/djiqf3usa/image/upload/v1768603677/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/structured-learning-path-sensual-bachata-online-dashboard_fnqrbk.webp",
        alt_content:
          "Structured learning path inside an online sensual bachata academy, showing clear progression on desktop and mobile",
      },

      version: "card_01",
    },

    {
      _id: "2",
      card_canva: false,
      card_heading: {
        style_render: "992",
        main_container_css: "",
        container_mobile_styles: {
          position: "absolute",
          top: "4rem",
          left: "2rem",
          right: "2rem",
          "max-width": "70rem",
          margin: "0 auto",
        },
        container_desktop_styles: {
          position: "absolute",
          top: "inherit",
          bottom: "3rem",
          "max-width": "70rem",
          margin: "0 auto",
        },
        obj_heading: {
          main_text:
            "<span class='t-enlace'>Start</span> From Zero. No Partner Needed",
          main_tag_version: "h3",
          main_text_css: "t-h-3",
          heading_mobile_styles: {
            "text-align": "center",
            "margin-bottom": "0.5rem",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          heading_desktop_styles: {},
        },
        obj_support_heading: false,

        obj_divider: {
          divider_mobile_styles: {
            width: "100%",
            background:
              "linear-gradient(90deg, transparent, #e6c28b, transparent)",
            margin: "0 auto 1.5rem auto",
          },
          divider_desktop_styles: false,
        },
        obj_paragraph: {
          main_text:
            "Begin with beginner-friendly courses designed to be simple, clear, and easy to follow. No experience, no partner, no pressure, just a proven way to start and actually learn",
          main_tag_version: "p",
          main_text_css: "",
          paragraph_mobile_styles: {
            "text-align": "center",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          paragraph_desktop_styles: false,
        },
        obj_buttons: false,
        heading_version: "heading_01",
      },

      card_content: {
        type: "video",
        src_content:
          "https://res.cloudinary.com/djiqf3usa/video/upload/v1769553693/Clients/LTMastery/Frontpage/Videos/start-sensual-bachata-from-zero-no-partner-required_u4z5b1.mov",
        alt_content: "",
      },
      version: "card_02",
    },

    {
      _id: "3",
      card_canva: {
        bg_color_mobile: "rgba(0, 0, 0, 0.2)",
        bg_color_desktop:
          "linear-gradient( to right, transparent 10%, rgb(0, 0, 0) 70%,rgba(0, 0, 0, 0.99) 75% )",
      },
      card_heading: {
        style_render: "992",
        main_container_css: "",
        container_mobile_styles: {
          position: "absolute",
          top: "4rem",
          left: "2rem",
          right: "2rem",
          "max-width": "70rem",
          margin: "0 auto",
        },
        container_desktop_styles: {
          bottom: "inherit",
          top: "10rem",
          left: "4.5rem",
          margin: "0",
        },
        obj_heading: {
          main_text: "<span class='t-enlace'>Train</span> Beyond the Basics",
          main_tag_version: "h3",
          main_text_css: "t-h-3",
          heading_mobile_styles: {
            "text-align": "center",
            "margin-bottom": "0.5rem",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          heading_desktop_styles: {
            "text-align": "left",
          },
        },
        obj_support_heading: false,

        obj_divider: {
          divider_mobile_styles: {
            width: "100%",
            background:
              "linear-gradient(90deg, transparent, #e6c28b, transparent)",
            margin: "0 auto 3rem auto",
          },
          divider_desktop_styles: {
            width: "70%",
            background: "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
            margin: "0 0 2rem 0",
          },
        },
        obj_paragraph: {
          main_text:
            "Go deeper with advanced courses focused on social technique, challenges, styling, and choreography, solo or in teams for dancers who want to level up",
          main_tag_version: "p",
          main_text_css: "",
          paragraph_mobile_styles: {
            "text-align": "center",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          paragraph_desktop_styles: {
            "text-align": "left",
          },
        },
        obj_buttons: false,
        heading_version: "heading_01",
      },

      card_content: {
        type: "video",
        src_content:
          "https://res.cloudinary.com/djiqf3usa/video/upload/v1769553701/Clients/LTMastery/Frontpage/Videos/sensual-bachata-training-beyond-the-basics-advanced_ajlbkm.mov",
        alt_content: "",
      },
      version: "card_03",
    },

    {
      _id: "4",
      card_canva: {
        bg_color_mobile: "rgba(0, 0, 0, 0.2)",
        bg_color_desktop:
          "linear-gradient( to right, transparent 10%, rgb(0, 0, 0) 70%,rgba(0, 0, 0, 0.99) 75% )",
      },
      card_heading: {
        style_render: "992",
        main_container_css: "",
        container_mobile_styles: false,
        container_desktop_styles: false,
        obj_heading: {
          main_text: "<span class='t-enlace'>Progress</span> You Can Feel",
          main_tag_version: "h3",
          main_text_css: "t-h-3",
          heading_mobile_styles: {
            "text-align": "center",
            "margin-bottom": "0.5rem",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          heading_desktop_styles: {
            "text-align": "left",
          },
        },
        obj_support_heading: false,

        obj_divider: {
          divider_mobile_styles: {
            width: "100%",
            background:
              "linear-gradient(90deg, transparent, #e6c28b, transparent)",
            margin: "0 auto 2rem auto",
          },
          divider_desktop_styles: {
            width: "70%",
            background: "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
            margin: "0 0 2rem 0",
          },
        },
        obj_paragraph: {
          main_text:
            "Train with Luis & Tay and experience real progress over time in your movement, confidence, and connection on and off the dance floor.",
          main_tag_version: "p",
          main_text_css: "",
          paragraph_mobile_styles: {
            "text-align": "center",
            "text-shadow":
              "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
          },
          paragraph_desktop_styles: {
            "text-align": "left",
          },
        },
        obj_buttons: false,
        heading_version: "heading_01",
      },

      card_content: {
        type: "img",
        src_content:
          "https://res.cloudinary.com/djiqf3usa/image/upload/v1768603035/Clients/LTMastery/Frontpage/Images/Imagenes%20con%20SEO/luis-and-tay-sensual-bachata-online-instructors-hero_enmpdq.webp",
        alt_content:
          "Luis and Tay helping dancers build confidence and progress through sensual bachata training",
      },

      version: "card_01",
    },
  ];
  return (
    <ContainerSection className="t-ptb-10">
      <div className="t-container">
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              "max-width": "100rem",
              "margin-bottom": "6rem",
            },
            container_desktop_styles: {},
            obj_heading: {
              main_text:
                "A Better Way to <span class='t-enlace'>Learn Bachata</span>",
              main_tag_version: "h2",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              main_text:
                "A clear learning path designed to help you progress with confidence, not confusion",
              main_tag_version: "h3",
              main_text_css: "t-h-4",
              heading_mobile_styles: {
                color: "#fff",
                "font-weight": "700",
                "margin-bottom": "1rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "70%",
                background:
                  "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: false,
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />

        <HighlightCarousel items={array_card} />
      </div>
    </ContainerSection>
  );
};

export default HighlightCard;
